export const FormatDate = (
    isoDate: string,
    options: {
        format?: 'YMD' | 'DMY';
        separator?: string;
    } = { format: 'YMD', separator: '-' }
): string => {
    const date = new Date(isoDate);
    if (isNaN(date.getTime())) {
        return 'Invalid Date';
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    const separator = options.separator ?? '-';

    if (options.format === 'DMY') {
        return `${day}${separator}${month}${separator}${year}`;
    }
    return `${year}${separator}${month}${separator}${day}`;
};
